<template>
<main-content v-if="$can('read', 'ivr-gateway')">
    <manage-ivr></manage-ivr>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import ManageIVR from './components/manage-ivr'

export default {
    components: {
        'main-content': mainContent,
        'manage-ivr': ManageIVR,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
}
</script>

<style>

</style>